export const METERS_IN_KM = 1000
export const METERS_IN_MILE = 1609.344

export const UNITS = { MI: 'mi', KM: 'km' }
export const isMiles = unit => unit !== UNITS.KM

export function metersToKm(meters) {
  if (meters == null) return 0
  return meters / METERS_IN_KM
}
export function kmToMeters(km) {
  if (km == null) return 0
  return km * METERS_IN_KM
}

export function metersToMiles(meters) {
  if (meters == null) return 0
  return meters / METERS_IN_MILE
}
export function milesToMeters(miles) {
  if (miles == null) return 0
  return miles * METERS_IN_MILE
}

export function metersToUnit(value, unit) {
  return unit === 'km' ? metersToKm(value) : metersToMiles(value)
}
export function unitToMeters(value, unit) {
  return unit === 'km' ? kmToMeters(value) : milesToMeters(value)
}

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value))
}
export function roundUpToStep(value, step) {
  if (!step) return value
  return Math.ceil(value / step) * step
}

export function roundToStep(value, step) {
  if (!step) return value
  const EPS = 1e-9
  return Math.round((value + EPS) / step) * step
}
export function snapUnitValue(value, { min, max, step }) {
  const clamped = clamp(value || 0, min, max)
  const stepped = roundToStep(clamped, step)
  return clamp(stepped, min, max)
}

export const MILES_SLIDER_CONFIG = { min: 2, max: 20, step: 2 }

export function getSliderConfig(unit, { radiusMinMeters = 10000, radiusMaxMeters = 50000, radiusStepMeters = 5000 } = {}) {
  if (unit === UNITS.KM) {
    return {
      min: metersToKm(radiusMinMeters),
      max: metersToKm(radiusMaxMeters),
      step: metersToKm(radiusStepMeters),
    }
  }
  return { ...MILES_SLIDER_CONFIG }
}

export function ensureCanonicalMeters(currentMeters, distanceUnit = UNITS.MI, config = MILES_SLIDER_CONFIG) {
  const meters = Number(currentMeters) || 0
  if (distanceUnit === UNITS.KM) {
    return Math.max(0, Math.round(meters))
  }
  const miles = metersToMiles(meters)
  const snappedMiles = snapUnitValue(miles, config)
  const snappedMeters = milesToMeters(snappedMiles)
  return Math.max(0, Math.round(snappedMeters))
}

export const getDistanceBetweenPoints = (lat1, lon1, lat2, lon2) => {
  if (!Number.isFinite(lat1) || !Number.isFinite(lon1) || !Number.isFinite(lat2) || !Number.isFinite(lon2)) return undefined

  const R = 6371e3 // metres
  const phi1 = (lat1 * Math.PI) / 180 // phi, lambda in radians
  const phi2 = (lat2 * Math.PI) / 180
  const deltaPhi = ((lat2 - lat1) * Math.PI) / 180
  const deltaLambda = ((lon2 - lon1) * Math.PI) / 180

  const a =
    Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
    Math.cos(phi1) * Math.cos(phi2) * Math.sin(deltaLambda / 2) * Math.sin(deltaLambda / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  return R * c // in metres
}

